import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { MarketplaceDetail } from '@anytag/graphql';
import { formatIntNumber } from '@anytag/shared-utils';
import { SelectorField, RangeSliderInputField, Filter, FILTER_SECTIONS } from '@anytag/shared-molecules';
import { useMarketplaceInfluencersFilterOptions } from '../../MarketplaceInfluencers';
import { MarketplaceApplicantsFilterFormKeys, MarketplaceApplicantsFilterFormValues } from './schemaTypes';
import { defaultMarketplaceApplicantsFilterValues } from './utils';
interface AdvancedFilterProps {
  count: number;
  onSubmit?: () => void;
  marketplace: MarketplaceDetail;
}

export const AdvancedFilter = ({ count, onSubmit, marketplace }: AdvancedFilterProps) => {
  const { t } = useTranslation();
  const { watch, reset } = useFormContext<MarketplaceApplicantsFilterFormValues>();
  const { ageConfigs, genderOptions, influencerCategoryOptions, followerConfigs, engagementRateConfigs } =
    useMarketplaceInfluencersFilterOptions({ marketplace });

  const values = watch();

  const handleClear = () => {
    reset({
      ...defaultMarketplaceApplicantsFilterValues,
      // Basic filter
      keyword: values.keyword,
      appliedStatus: values.appliedStatus
    });
  };

  return (
    <Filter.MoreFilterPopover
      count={count}
      onClear={handleClear}
      onSubmit={onSubmit}
      items={[
        {
          value: FILTER_SECTIONS.InfluencerAttributes,
          title: FILTER_SECTIONS.InfluencerAttributes,
          node: (
            <>
              <SelectorField<MarketplaceApplicantsFilterFormKeys>
                name="genders"
                options={genderOptions}
                title={t('Selector.Gender')}
                multiple
              />
              <SelectorField<MarketplaceApplicantsFilterFormKeys>
                name="categoryIds"
                title={t('Selector.Categories')}
                options={influencerCategoryOptions}
                multiple
              />
            </>
          )
        },
        {
          value: FILTER_SECTIONS.PerformanceFilter,
          title: FILTER_SECTIONS.PerformanceFilter,
          node: (
            <>
              <RangeSliderInputField<MarketplaceApplicantsFilterFormKeys>
                title={t('General.Age')}
                options={ageConfigs.options}
                slideProps={ageConfigs.slideProps}
                minField={{ name: 'minAge', placeholder: `${ageConfigs.slideProps.min}` }}
                maxField={{ name: 'maxAge', placeholder: `${ageConfigs.slideProps.max}` }}
              />
              <RangeSliderInputField<MarketplaceApplicantsFilterFormKeys>
                options={followerConfigs.options}
                slideProps={followerConfigs.slideProps}
                title={t('General.Number of Followers')}
                minField={{ name: 'minFollowers', placeholder: formatIntNumber(followerConfigs.slideProps.min) }}
                maxField={{ name: 'maxFollowers', placeholder: `${formatIntNumber(followerConfigs.slideProps.max)}+` }}
              />
              <RangeSliderInputField<MarketplaceApplicantsFilterFormKeys>
                title={t('General.Engagement Rate')}
                options={engagementRateConfigs.options}
                slideProps={engagementRateConfigs.slideProps}
                minField={{ name: 'minEngagementRate', placeholder: `${engagementRateConfigs.slideProps.min}%` }}
                maxField={{ name: 'maxEngagementRate', placeholder: `${engagementRateConfigs.slideProps.max}%` }}
              />
            </>
          )
        }
      ]}
    />
  );
};
